export const PATCH_COMMENT_REQUEST = "PATCH_COMMENT_REQUEST"
export const PATCH_COMMENT_SUCCESS = "PATCH_COMMENT_SUCCESS"
export const PATCH_COMMENT_FAILURE = "PATCH_COMMENT_FAILURE"

export const POST_NEW_DISCUSSION = "POST_NEW_DISCUSSION"

export const GET_ALL_DISCUSSIONS = "GET_ALL_DISCUSSIONS"